class AANTable {
	init() {
		const tables = Array.from(document.querySelectorAll("table")) as HTMLTableElement[];

		tables.forEach(table => {
			const tableHeaders = Array.from(table.querySelectorAll("thead th, thead td")) as HTMLTableHeaderCellElement[];
			const tableRows = Array.from(table.querySelectorAll("thead ~ tbody tr")) as HTMLTableRowElement[];

			this.forceMobileIfNeeded(table);

			if (!tableHeaders || tableHeaders.length === 0) {
				return;
			}

			tableRows.forEach(row => {
				const columns = row.querySelectorAll("td");

				for (let i = 0, len = columns.length; i < len; i++) {
					const column = columns[i];
					const tableHeader = tableHeaders[i];
					if (!column.hasAttribute("data-label") && tableHeader) {
						column.setAttribute("data-label", tableHeader.innerText);
					}
				}
			});
		});

		window.addEventListener("resize", () => {
			tables.forEach(table => {
				this.forceMobileIfNeeded(table);
			});
		});
	}

	/**
	 * Check if the table is too wide compared to the parent, if so then add a class to force it to display as mobile.
	 * */
	private forceMobileIfNeeded(table: HTMLTableElement) {
		table.classList.remove("force-mobile");
		if(!table.parentElement) {
			return;
		}
		const parentStyles = getComputedStyle(table.parentElement);
		const tableStyles = getComputedStyle(table);
		const parentWidth = parseInt(parentStyles.width);
		const tableWidth = parseInt(tableStyles.width) + parseInt(tableStyles.marginLeft) + parseInt(tableStyles.marginRight);
		// debugger;

		if (parentWidth < tableWidth) {
			table.classList.add("force-mobile");
		}
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const table = new AANTable();
	table.init();
});
